var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppAccessEnable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 12,
    fill: "#2BA9DE",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9991889,16.1755924L9.5977812,16.7585354C9.9283748,17.080486999999998,10.4643731,17.080488000000003,10.7949672,16.7585363L18.752055,8.9906679C19.082649,8.6687173,19.082649,8.1464827,18.752055,7.8245315600000005L18.153458,7.2414633C17.822865,6.919512033,17.286855,6.919512428,16.956262000000002,7.2414633L10.1966481,13.8435497L7.0440052,10.7545207C6.7134116,10.4325697,6.1774037,10.4325697,5.84680992,10.7545207L5.2479452,11.337588799999999C4.917351559,11.6595397,4.917351559,12.1817746,5.2479452,12.5037255L8.9991889,16.1755924Z",
    fillRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppAccessEnable);
export default __webpack_public_path__ + "static/media/AppAccessEnable.4fa7de0a5379d62ea8cac8cce5e5a66c.svg";
export { ForwardRef as ReactComponent };